import { render, staticRenderFns } from "./VideoGuide.vue?vue&type=template&id=299f74c2&scoped=true"
import script from "./VideoGuide.vue?vue&type=script&lang=js"
export * from "./VideoGuide.vue?vue&type=script&lang=js"
import style0 from "./VideoGuide.vue?vue&type=style&index=0&id=299f74c2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "299f74c2",
  null
  
)

export default component.exports